<template>
    <ReportContainer>
      <template #filter>
        <b-form-group
          label="From">
          <b-form-datepicker  v-model="filters.collection.dateFrom"
            :date-format-options="{
              'year': 'numeric', 'month': 'long', 'day': 'numeric'
            }"/>
        </b-form-group>
         <b-form-group
          label="To">
          <b-form-datepicker  v-model="filters.collection.dateTo"
            :date-format-options="{
              'year': 'numeric', 'month': 'long', 'day': 'numeric'
            }"/>
        </b-form-group>
        <b-form-group label="Order By" v-slot="{ ariaDescribedby }">
          <b-form-radio-group
            v-model="filters.collection.orderBy"
            :aria-describedby="ariaDescribedby"
          >
            <b-form-radio value="transaction_date">Date</b-form-radio>
            <b-form-radio value="payment_no" >Payment  No</b-form-radio>
            <b-form-radio value="transaction_no">Ack. Receipt</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group label="Order Direction" v-slot="{ ariaDescribedby }">
          <b-form-radio-group
            v-model="filters.collection.orderDesc"
            :aria-describedby="ariaDescribedby"
          >
            <b-form-radio value="ASC">ASC</b-form-radio>
            <b-form-radio value="DESC" >DESC</b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-button variant="outline-primary" @click="onPreviewCollection">Preview</b-button>
      </template>
      <template #content>
        <ReportViewer :reportSource="file.src" :isLoading="file.isLoading"/>
      </template>
    </ReportContainer>
</template>

<script>
import { ReportApi } from '../../mixins/api'
import ReportContainer from '../components/ReportContainer'
import ReportViewer from '../components/ReportViewer'
import { format } from 'date-fns'
export default {
  format,
  components: {
    ReportContainer,
    ReportViewer
  },
  mixins: [ ReportApi ],
  data() {
    return {
      reportSource: '',
      isLoading: false,
      filters:{
        collection: {
          dateFrom: new  Date(),
          dateTo: new  Date(),
          orderBy: 'transaction_no',
          orderDesc: 'ASC'
        }
      },
      file: {
        src: '',
        isLoading: false
      }
    }
  },
  methods: {
    onPreviewCollection() {
      this.file.src = ''
      this.file.isLoading = true
      const { dateFrom, dateTo, orderBy, orderDesc } = this.filters.collection

      const params = {
        dateFrom: this.$options.format(new Date(dateFrom), 'MM/dd/yyyy'),
        dateTo: this.$options.format(new Date(dateTo), 'MM/dd/yyyy'),
        orderBy,
        orderDesc
      }

      this.previewCollectionDetailed(params).then(response  => {
        const file = new Blob([response.data], { type: "application/pdf" } )
          const reader = new FileReader();
          reader.onload = e => this.file.src = e.target.result
          reader.readAsDataURL(file);
          this.file.isLoading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .collection-detailed__container {
    height: 100%;
    width: 100%;
  }
</style>
